/* Temporary public-CDN compatibility bridge for the atc-demo product template.
   The primary product script sets the V2 marker and owns this behavior once
   Shopify serves its current asset revision. */
(function () {
  if (window.__bfeJewelleryPairDefaultsV2) return;

  var defaults = {
    'original-necklace': 'infinity-butterfly-necklace',
    'infinity-butterfly-necklace': 'original-necklace',
    'cross-of-hope': 'original-necklace',
    'promise-bracelet': 'original-necklace'
  };
  var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
  var primaryHandle = match && match[1];
  var targetHandle = primaryHandle && defaults[primaryHandle];
  if (!targetHandle) return;

  var initialized = new WeakSet();

  function initialize(widget) {
    if (!widget || initialized.has(widget) || widget.hasAttribute('data-bfe-default-pair')) return;
    initialized.add(widget);

    var state = { stage: 'waiting', finish: '', modal: null };
    var style = document.createElement('style');
    var timer;
    var poll;
    style.textContent = 'html[data-bfe-seeding-jewellery-pair] .kaching-bundles__choose-product-modal { visibility: hidden; }';

    function finish(status) {
      observer.disconnect();
      window.clearTimeout(timer);
      window.clearInterval(poll);
      widget.removeEventListener('pointerdown', onInteraction, true);
      widget.removeEventListener('keydown', onInteraction, true);
      document.documentElement.removeAttribute('data-bfe-seeding-jewellery-pair');
      style.remove();
      widget.setAttribute('data-bfe-default-pair', status);
      state.stage = 'finished';
    }

    function onInteraction(event) {
      if (event.isTrusted && state.stage !== 'finished') finish('customer-selected');
    }

    function selectedPairBar() {
      return Array.prototype.find.call(widget.querySelectorAll('.kaching-bundles__bar'), function (bar) {
        var heading = bar.querySelector('.kaching-bundles__bar-title, .kaching-bundles__bar-main');
        return /Any\s*2\s*Pieces/i.test((heading || bar).textContent || '');
      });
    }

    function step() {
      if (state.stage === 'finished') return;
      var bar = selectedPairBar();
      if (!bar) return;

      if (!bar.classList.contains('kaching-bundles__bar--selected')) {
        if (state.stage !== 'waiting') return;
        var selectPair = bar.querySelector('.kaching-bundles__bar-main, [role="button"]');
        if (selectPair) selectPair.click();
        return;
      }

      var pieces = bar.querySelectorAll('.kaching-bundles__collection-product');
      var first = pieces[0];
      var second = pieces[pieces.length - 1];
      if (second && second.querySelector('a[href*="/products/' + targetHandle + '"]')) return finish('ready');

      if (state.stage === 'waiting') {
        if (!second || !second.querySelector('a[href*="/products/' + primaryHandle + '"]')) return;
        var finishSelect = first && first.querySelector('.kaching-bundles__bar-variant-select');
        state.finish = finishSelect ? finishSelect.value : '';
        var remove = second.querySelector('.kaching-bundles__collection-product__remove-button');
        if (!remove) return;
        state.stage = 'choose';
        document.head.append(style);
        document.documentElement.setAttribute('data-bfe-seeding-jewellery-pair', '');
        remove.click();
        return;
      }

      state.modal = document.querySelector('.kaching-bundles__choose-product-modal');
      if (state.stage === 'choose') {
        if (state.modal) {
          state.stage = 'modal';
          return;
        }
        var chooser = bar.querySelector('.kaching-bundles__collection-product__choose-product-button');
        if (chooser) chooser.click();
        return;
      }

      if (state.stage === 'modal') {
        if (!state.modal) return;
        var link = state.modal.querySelector('a[href*="/products/' + targetHandle + '"]');
        var card = link && link.closest('.kaching-bundles__choose-product__product');
        var select = card && card.querySelector('.kaching-bundles__bar-variant-select');
        if (!card) return;
        if (select && state.finish && Array.prototype.some.call(select.options, function (option) { return option.value === state.finish; })) {
          if (select.value !== state.finish) {
            select.value = state.finish;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        state.stage = 'select-product';
        return;
      }

      if (state.stage === 'select-product') {
        state.modal = document.querySelector('.kaching-bundles__choose-product-modal');
        var targetLink = state.modal && state.modal.querySelector('a[href*="/products/' + targetHandle + '"]');
        var targetCard = targetLink && targetLink.closest('.kaching-bundles__choose-product__product');
        var choose = targetCard && targetCard.querySelector('.kaching-bundles__choose-product__product-button');
        if (choose && choose.getAttribute('aria-disabled') !== 'true') {
          state.stage = 'verify';
          choose.click();
        }
        return;
      }

      if (state.stage === 'verify') {
        var selected = bar.querySelector('.kaching-bundles__collection-product a[href*="/products/' + targetHandle + '"]');
        if (!selected) return;
        var selectedCard = selected.closest('.kaching-bundles__collection-product');
        var selectedFinish = selectedCard && selectedCard.querySelector('.kaching-bundles__bar-variant-select');
        if (!state.finish || !selectedFinish || selectedFinish.value === state.finish) finish('ready');
      }
    }

    var observer = new MutationObserver(step);
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'collection-breaks-products'] });
    widget.addEventListener('pointerdown', onInteraction, true);
    widget.addEventListener('keydown', onInteraction, true);
    timer = window.setTimeout(function () {
      var close = state.modal && state.modal.querySelector('.kaching-bundles__choose-product__close');
      if (close) close.click();
      finish('unavailable');
    }, 30000);
    poll = window.setInterval(step, 100);
    step();
  }

  function scan() {
    document.querySelectorAll('kaching-bundles-block').forEach(initialize);
  }

  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  scan();
})();
